import { getCompanyProfile, putCompanyProfile } from '@/api/settings.api'
import { getCountries, getCityByCountry } from '@/api/country.api'

export const FETCH_COMPANY = 'FETCH_COMPANY'
export const FETCH_COMPANY_LOADING = 'FETCH_COMPANY_LOADING'
export const FETCH_COMPANY_DONE = 'FETCH_COMPANY_DONE'
export const FETCH_COMPANY_ERROR = 'FETCH_COMPANY_ERROR'

export const UPDATE_COMPANY = 'UPDATE_COMPANY'
export const UPDATE_COMPANY_LOADING = 'UPDATE_COMPANY_LOADING'
export const UPDATE_COMPANY_DONE = 'UPDATE_COMPANY_DONE'
export const UPDATE_COMPANY_ERROR = 'UPDATE_COMPANY_ERROR'

export const FETCH_COUNTRIES = 'FETCH_COUNTRIES'
export const FETCH_COUNTRIES_LOADING = 'FETCH_COUNTRIES_LOADING'
export const FETCH_COUNTRIES_DONE = 'FETCH_COUNTRIES_DONE'
export const FETCH_COUNTRIES_ERROR = 'FETCH_COUNTRIES_ERROR'

export const FETCH_CITY_BY_COUNTRIES = 'FETCH_CITY_BY_COUNTRIES'
export const FETCH_CITY_BY_COUNTRIES_LOADING = 'FETCH_CITY_BY_COUNTRIES_LOADING'
export const FETCH_CITY_BY_COUNTRIES_DONE = 'FETCH_CITY_BY_COUNTRIES_DONE'
export const FETCH_CITY_BY_COUNTRIES_ERROR = 'FETCH_CITY_BY_COUNTRIES_ERROR'

export default {
  [FETCH_COMPANY] (context) {
    context.commit(FETCH_COMPANY_LOADING)
    return getCompanyProfile()
      .then((response) => {
        context.commit(FETCH_COMPANY_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_COMPANY_ERROR, error)
        console.error(error)
      })
  },

  [UPDATE_COMPANY] (context, payload) {
    context.commit(UPDATE_COMPANY_LOADING)
    return putCompanyProfile(payload)
      .then((response) => {
        context.commit(UPDATE_COMPANY_DONE, response)
      })
      .catch((error) => {
        context.commit(UPDATE_COMPANY_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_COUNTRIES] (context) {
    context.commit(FETCH_COUNTRIES_LOADING)
    return getCountries()
      .then((response) => {
        context.commit(FETCH_COUNTRIES_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_COUNTRIES_ERROR, error)
        console.error(error)
      })
  },

  [FETCH_CITY_BY_COUNTRIES] (context, idCountry) {
    context.commit(FETCH_CITY_BY_COUNTRIES_LOADING)
    return getCityByCountry(idCountry)
      .then((response) => {
        context.commit(FETCH_CITY_BY_COUNTRIES_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_CITY_BY_COUNTRIES_ERROR, error)
        console.error(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/company/actions.js